import React from 'react'

const style = {
   status: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'rgba(242, 108, 108, 0.3)',
      color: '#F26C6C',
      padding: '4px 14px',
      borderRadius: '40px'
   },
   dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#F26C6C',
      display: 'inline-block'
   }
}

export default function Inactive() {
   return (
      <span style={style.status}>
         <span style={style.dot} />
         &nbsp;Inactivo
      </span>
   )
}
